<template>
  <el-dialog title="分配角色"
             :visible.sync="showModal"
             :close-on-click-modal="false"
             @close="handleCancel"
             width="80%">
    <el-row :gutter="10">
      <el-col :span="6">
        <el-card shadow="none"
                 class="bt-border4">
          <div class="alignCenter">
            <p class="card-text mb-20">
              <el-image style="width: 100px; height: 100px"
                        :src="userInfo.avatar"></el-image>
            </p>
            <p class="card-text">姓名：{{ userInfo.name }}</p>
            <p class="card-text">性别：{{ userInfo.sex }}</p>
            <p class="card-text">联系方式：{{ userInfo.mobile }}</p>
            <el-divider></el-divider>
            <p class="card-text">系统角色：{{ userInfo.sysAuth }}</p>
            <p class="card-text">管理角色：{{ userInfo.mageAuth }}</p>
          </div>
        </el-card>
      </el-col>
      <el-col :span="18">
        <el-card shadow="none">
          <div>
            <el-row :gutter="10">
              <el-col :span="24">
                <p class="item-title">系统权限</p>
                <el-col v-for="(item, index) in userInfo.sysData"
                        :key="index"
                        :xs="12"
                        :span="4">
                  <div class="auth-item mb-10">
                    <i class="el-icon-discount mr-10"></i>
                    <span class="card-text"
                          :title="item">{{ item }}</span>
                  </div>
                </el-col>
              </el-col>
              <el-col :span="24"
                      class="mt-15">
                <p class="item-title">管理权限</p>
                <el-col v-for="(item, index) in userInfo.mageData"
                        :key="index"
                        :xs="12"
                        :span="4">
                  <div class="auth-item mb-10">
                    <i class="el-icon-discount mr-10"></i>
                    <span class="card-text"
                          :title="item">{{ item }}</span>
                  </div>
                </el-col>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <div slot="footer"
         class="dialog-footer">
      <el-button type="primary"
                 @click="handleCancel">
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import fetch from '@/common/api'
export default {
  props: {
    isShow: {
      type: Boolean
    },
    data: {
      type: Object
    }
  },
  data() {
    return {
      showModal: this.isShow,
      userInfo: {
        avatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
        name: '小陈',
        sex: '女',
        mobile: '13627392031',
        sysAuth: '系统管理员',
        mageAuth: '12',
        sysData: ['设备管理', '基础设置', '人员管理', '系统设置'],
        mageData: [
          '11号楼',
          '17号楼',
          '19号楼',
          '21号楼',
          '23号楼',
          '教学楼',
          '不要睡图书馆',
          '活动中心',
          '二楼充值室'
        ]
      }
    }
  },
  created() {
    this.getInfo()
    this.getRole()
  },
  methods: {
    // 获取编辑信息
    getInfo() {
      fetch.getUserInfo({ id: this.data.id }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.userInfo.user_role = data.user_role ? data.user_role.split(',') : []
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 获取角色数据
    getRole() {
      fetch.getRoleList({}).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.sysRoleList = data.list
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    handleCancel() {
      this.$emit('handleClose')
    }
  }
}
</script>

<style lang="less" scoped>
.auth-item {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 15px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  i {
    color: #409eff;
  }
}
</style>
